export const currencyConstants = {
    GET_CURRENCY_REQUEST: 'GET_CURRENCY_REQUEST',
    GET_CURRENCY_SUCCESS: 'GET_CURRENCY_SUCCESS',
    GET_CURRENCY_FAILURE: 'GET_CURRENCY_FAILURE',

    CREATE_CURRENCY_REQUEST: 'CREATE_CURRENCY_REQUEST',
    CREATE_CURRENCY_SUCCES: 'CREATE_CURRENCY_SUCCES',
    CREATE_CURRENCY_FAILURE: 'CREATE_CURRENCY_FAILURE',

    UPDATE_CURRENCY_REQUEST: 'UPDATE_CURRENCY_REQUEST',
    UPDATE_CURRENCY_SUCCESS: 'UPDATE_CURRENCY_SUCCESS',
    UPDATE_CURRENCY_FAILURE: 'UPDATE_CURRENCY_SUCCESS',

    DELETE_CURRENCY_REQUEST: 'DELETE_CURRENCY_REQUEST',
    DELETE_CURRENCY_SUCCESS: 'DELETE_CURRENCY_SUCCESS',
    DELETE_CURRENCY_FAILURE: 'DELETE_CURRENCY_FAILURE',

    DELETE_CURRENCY_BLOCKED: 'DELETE_CURRENCY_BLOCKED',
};
